import * as React from 'react';

var _path, _path2;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.72 17.617l-6.134 6.046.702.712 6.144-6.056 6.144 6.056.702-.712-6.134-6.046 6.133-6.046-.702-.712-6.143 6.056-6.143-6.056-.703.712 6.134 6.046z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.963 2.68a15.5 15.5 0 10-11.862 28.64A15.5 15.5 0 0022.963 2.68zM13.813.817a16.5 16.5 0 116.439 32.366A16.5 16.5 0 0113.812.817z"
  })));
}

export { SvgClose as default };